import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { HandlerService } from '../handler.service';

@Component({
  selector: 'app-purchase-items',
  templateUrl: './purchase-items.component.html',
  styleUrls: ['./purchase-items.component.scss'],
})
export class PurchaseItemsComponent {

  loader:boolean=false;
  url;
  id;
  resId;
  ChangeInc:boolean=false;
  changeId;
  Type;
  reasons;
  purrchaseItems:any=[];
  returnReasons;
  returnCheck:boolean=false;
  returnValue;
  reqId;

  constructor(public auth: AuthService,private router: Router, public handler: HandlerService,
    public service: ApiService) { }

ionViewWillEnter(){
  this.url = window.location.href; 
  this.id = this.url.split('/').pop();
  this.getOrder();
  this.getReasons();
  this.getChange();
}

getOrder(){
  this.loader=true;
  this.service.getOrderById(this.id).subscribe((res:any) => {
    if (res) {
     this.purrchaseItems = res.serviceRequests;
     this.loader =false;
    }
  },
    err => {
      this.loader = false;
      this.handler.err(err.error)
    })
}


finish(){
  this.service.deliverOrder(this.id).subscribe((res:any)=>{
    this.handler.res('Status Updated Successfully !!');
      this.router.navigate(['/delivery'])
   
  })
}

getReasons(){
  this.service.reasonsForReturn().subscribe((res: any) => {
    this.returnReasons = res;
  })
}

notFixed(id){
  this.returnCheck=true;
  this.reqId = id;
}

clearArray1(value){
  this.returnValue=value.id;
}

submit(){
  this.loader = true;
  let post = {
    "id":this.reqId,
    "status": 11,
    "reasonsNotFixed":this.returnValue
    }
  this.service.notFixed(this.reqId,post).subscribe((res:any)=>{ 
    this.handler.res('Status Updated Successfully !!')
    this.returnCheck=false;
    this.loader = false;
    this.getOrder();
   },
  err=>{
    this.loader=false;
    this.handler.err(err)
  })
}

Completed(id){
  this.loader = true;
  let post = {
    "id":id,
    "status": 3,
   }
     this.service.completed(post,id).subscribe((res:any)=>{
    this.handler.res('Status Updated Successfully !!')
    this.loader=false;
    this.getOrder();
    
  },
  err=>{
    this.loader=false;
    this.handler.err(err)
  })
}

cancel(){
    this.router.navigate(['/delivery'])
  
}

getChange(){
  this.service.getReasons().subscribe(res =>{ 
    this.reasons = res;
  }) 
}

getReason(id){
  this.resId=id;
  this.ChangeInc=true;
}
clearArray(value){
  this.changeId=value.id;
}
clearCapture(){
  this.ChangeInc = false;
  this.updateReason();
}

updateReason(){
  this.loader=true;
  let post = {
    "id":this.resId,
    "status": 2,
    "reason":this.changeId  
  }
  this.service.updateReasons(post,this.resId).subscribe((res:any)=>{
    this.handler.res('Status Updated Successfully !!')
    this.Type="";
    this.loader=false;
    this.getOrder();

  },
  err=>{
    this.loader=false;
    this.handler.err(err)
  }) 
}
}
